import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useCallback } from 'react';

const useMovementWorkspaceMutations = () => {
  const { enqueueSnackbar } = useSnackbar();

  const request = useCallback(
    (promise, { successMessage } = {}) =>
      promise
        .then(res => {
          if (res.status === 200) {
            if (successMessage) {
              enqueueSnackbar(successMessage, { variant: 'success' });
            }
            return !!res.data.value ? res.data?.value : res.data;
          }
          enqueueSnackbar(res?.message, { variant: 'error' });
          return null;
        })
        .catch(err => {
          enqueueSnackbar(err?.message || err?.response?.data?.message, {
            variant: 'error',
          });
          return null;
        }),
    [enqueueSnackbar],
  );

  const insertAgent = useCallback(
    payload =>
      request(
        axiosClient.post('Operation/Movement/Agent/Insert', {
          operationGuid: payload.operationGuid,
          agentGuid: payload.agentGuid,
        }),
        { successMessage: 'کاربر با موفقیت انتخاب شد' },
      ),
    [request],
  );

  const updateAgent = useCallback(
    payload =>
      request(
        axiosClient.put('Operation/Movement/Agent/Update', {
          operationGuid: payload.operationGuid,
          agentGuid: payload.agentGuid,
        }),
        { successMessage: 'کاربر با موفقیت تغییر یافت' },
      ),
    [request],
  );

  const prepareOrigin = useCallback(
    payload =>
      request(
        axiosClient.post('Operation/Movement/Task/PrepareOrigin', {
          operationGuid: payload.operationGuid,
          cellGuid: payload.cellGuid,
          count: payload.count,
        }),
      ),
    [request],
  );

  const prepareDestination = useCallback(
    payload =>
      request(
        axiosClient.post('Operation/Movement/Task/PrepareDestination', {
          operationGuid: payload.operationGuid,
          cellGuid: payload.cellGuid,
        }),
      ),
    [request],
  );

  const runMovement = useCallback(
    taskGuid =>
      request(
        axiosClient.put('Operation/Movement/Task/Run', {
          guid: taskGuid,
        }),
        { successMessage: 'جابجایی انجام شد.' },
      ),
    [request],
  );

  return {
    insertAgent,
    updateAgent,
    prepareOrigin,
    prepareDestination,
    runMovement,
  };
};

export { useMovementWorkspaceMutations };
